import api from "./services/mkm.api.js"

const resource = "/powerapp/fortbildungsgruppe"

export default{
    alle() {
        return api.get(`${resource}`);
    }
}